import React, { useEffect, useState } from "react";
import PartnerDealsTable from "./components/partner-deals-table/PartnerDealsTable";
import { Button } from "antd";
import GeneralTableHeader from "../common/general-table-header/GeneralTableHeader";
import { PlusCircleOutlined, AccountBookOutlined } from "@ant-design/icons";
import styles from "./PartnerDeals.module.css";
import DealWizard from "./components/deal-wizard/DealWizard";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  selectIsKlearlyAdmin,
  selectUserPartnerId,
} from "../access-control/accountSlice";
import { getPartnerThunk } from "../partners/partnersSlice";
import InviteMerchantLink from "./components/invite-merchant-link/InviteMerchantLink";

export default function PartnerDeals() {
  const [isCreateWizardVisible, setIsCreateWizardVisible] = useState(false);

  const partnerId = useAppSelector(selectUserPartnerId);
  const isKlearlyAdmin = useAppSelector(selectIsKlearlyAdmin);

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (partnerId) {
      fetchPartner(partnerId);
    }
  }, []);

  const fetchPartner = async (partnerId: string) => {
    await dispatch(getPartnerThunk(partnerId));
  };

  return (
    <div className={styles.container}>
      {!isKlearlyAdmin}
      {/* {<InviteMerchantLink />} */}
      <GeneralTableHeader
        title="Custom Merchant Deals"
        description=" Create new merchants and set pricing for them. You can list future
        merchants here, as merchants will not be notified or contacted."
        avatarUrl={<AccountBookOutlined style={{ fontSize: "30px" }} />}
        actionButtons={[
          <Button
            key="create"
            type="primary"
            onClick={() => setIsCreateWizardVisible(true)}
            icon={<PlusCircleOutlined></PlusCircleOutlined>}
            size={"middle"}
          >
            Create deal
          </Button>,
        ]}
      />
      <PartnerDealsTable />
      <DealWizard
        mode="create"
        visible={isCreateWizardVisible}
        setVisible={setIsCreateWizardVisible}
      />
    </div>
  );
}
